import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const totalWidgetStyles = makeStyles((theme: Theme) =>
    createStyles({
        widgetContainer: {
            width: "312px",
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "white",
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "15px",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },

        widget: {
            position: "relative",
            width: "170px",
            height: "170px",
            display: "flex",
            alignItems: "center",
        },

        title: {
            alignSelf: "start",
            fontSize: "14px",
            lineHeight: "14px",
            fontWeight: 600,
            color: theme.colors.neutrals.neutral500,
            textTransform: "uppercase",
            marginBottom: "10px",
        },

        textContainer: {
            zIndex: -1,
            position: "absolute",
            left: 0,
            top: 5,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            color: theme.colors.neutrals.neutral500,
        },

        mainText: {
            fontSize: "18px",
            lineHeight: "21px",
            fontWeight: 600,
        },

        subText: {
            textTransform: "capitalize",
        },
    })
);
